import HistoricOrderVM from '@/react/view-models/HistoricOrderVM';
import { createContext } from 'react';

/**
 * The context used for order cancellation which relies on the {@link HistoricOrderVM}.
 * @returns - An instance of the {@link HistoricOrderVM} which should be
 * initialized.
 */
export const OrderCancellationContext = createContext<HistoricOrderVM>(
  new HistoricOrderVM()
);

OrderCancellationContext.displayName = 'OrderCancellationContext';
